import React from "react";
import { Fab } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";

const FloatingButtonSx = {
  position: "fixed",
  bottom: 60,
  right: 5,
  minHeight: "30px",
  width: "30px",
  height: "30px",
};

const CustomFloatingButton = ({ onClick = () => {} }) => {
  return (
    <Fab
      size="small"
      color="primary"
      aria-label="settings"
      onClick={onClick}
      sx={FloatingButtonSx}
    >
      <SettingsIcon fontSize="small" />
    </Fab>
  );
};

export default CustomFloatingButton;
